// frontend/src/AppRoutes.tsx
import { lazy, Suspense } from 'react'
import { Route } from 'react-router-dom'
import { AppLoadingOrError } from '~m/AppUi/components/AppLoadingOrError.tsx'
import { SentryRoutes } from '~/instrument.ts'
import { AuthProvider } from '~m/auth/context/AuthProvider.tsx'
import { SnackbarProvider } from '@pogokid/mui'

const HomePage = lazy(() => import('./pages/index'))
const HandlePage = lazy(() => import('./pages/[handle]/index.tsx'))
const DashboardPage = lazy(() => import('./pages/dashboard'))
const FaqPage = lazy(() => import('./pages/faq'))
const GetStartedPage = lazy(() => import('./pages/getstarted'))
const InvitePage = lazy(() => import('./pages/invite/[id]/index.tsx'))
const PayPage = lazy(() => import('./pages/pay/[link]/index.tsx'))
const PricingPage = lazy(() => import('./pages/pricing'))
const SignInPage = lazy(() => import('./pages/signin'))
const SignOutPage = lazy(() => import('./pages/signout'))
const AboutPage = lazy(() => import('./pages/about/us'))
const CareersPage = lazy(() => import('./pages/about/careers'))
const PrivacyPage = lazy(() => import('./pages/legal/privacy'))
const TermsPage = lazy(() => import('./pages/legal/terms'))
const FoundingMembersPage = lazy(() => import('./pages/founding-members'))
const DesignSystemPage = lazy(() => import('./pages/design-system'))
const DesignSystemComponentPage = lazy(
  () => import('./pages/design-system/[component]/index.tsx'),
)

export default function AppRoutes() {
  return (
    <SnackbarProvider>
      <AuthProvider>
        <Suspense fallback={<AppLoadingOrError message="Loading..." />}>
          <SentryRoutes>
            <Route path="/" element={<HomePage />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="getstarted" element={<GetStartedPage />} />
            <Route path="faq" element={<FaqPage />} />
            <Route path="pricing" element={<PricingPage />} />
            <Route path="about/us" element={<AboutPage />} />
            <Route path="about/careers" element={<CareersPage />} />
            <Route path="legal/privacy" element={<PrivacyPage />} />
            <Route path="legal/terms" element={<TermsPage />} />
            <Route path="founding-members" element={<FoundingMembersPage />} />
            <Route path="signin" element={<SignInPage />} />
            <Route path="signout" element={<SignOutPage />} />
            <Route path="invite/:id" element={<InvitePage />} />
            <Route path="pay/:link" element={<PayPage />} />
            <Route path="design-system">
              <Route index element={<DesignSystemPage />} />
              <Route path=":component" element={<DesignSystemComponentPage />} />
            </Route>
            <Route path=":handle/*">
              <Route path="*" element={<HandlePage />} />
            </Route>
          </SentryRoutes>
        </Suspense>
      </AuthProvider>
    </SnackbarProvider>
  )
}
